<template>
  <div class="account" style="background: #fff;">
    <accountForm
    :isEdit="isEdit"
    :formObjError="formObjError"
    @accountWay="addAccount"
    ></accountForm>
  </div>
</template>
<script>
import accountForm from './accountForm'
import { getAddAccount } from '@/api/app'
export default {
  name: 'add-account',
  created() {
    this.$store.dispatch('setPage', { title: '新增账号', type: 'default' })
  },
  components: { accountForm },
  data() {
    return {
      isEdit: false,
      formObjError: {
        accountName: ''
      }
    }
  },
  methods: {
    // 新增账号
    addAccount(data) {
      this.formObjError.accountName = ''
      getAddAccount({
        admin_name: data.accountName,
        admin_password: data.passwd,
        admin_rpassword: data.passwdCheck,
        gid: data.grouping
      }).then(res => {
        if (res.code === 0) {
          localStorage.removeItem('isNull')
          this.$router.push({ name: 'accountList' })
        } else if (res.code === 10301) {
          this.formObjError.accountName = res.msg
        }
      })
    }
  },
  mounted() {
  }
}
</script>
<style lang="scss"></style>
